import { BrowserRouter,Route,Routes,Navigate, NavLink } from 'react-router-dom'
import './App.scss';
import { NavBar } from './components/NavBar/NavBar';
import { MyCareersPage } from './pages/CareersPage/MyCareersPage';
import { HowWorksContainer } from './components/HowWorksContainer/HowWorksContainer';
import { useState } from 'react';
import { AddCareerContainer } from './components/AddCareerContainer/AddCareerContainer';
import { LoginPage } from './pages/LoginPage/LoginPage';
import { RegisterPage } from './pages/RegisterPage/RegisterPage';
import { DeleteCareerContainer } from './components/DeleteCareerContainer/DeleteCareerContainer';
import ForgotPasswordPage from './pages/ForgotPasswordPage/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage/ResetPasswordPage';
import VerificacionMailPage from './pages/VerificationPage/VerificacionMailPage';
import { FAQPage } from './pages/FAQPage/FAQPage';
import { HomeContainer } from './components/HomeContainer/HomeContainer';
import { AddOpinionContainer } from './components/AddOpinionContainer/AddOpinionContainer';
import { AddTutorContainer } from './components/AddTutorContainer/AddTutorContainer';
import { getTutorByUser } from './data/api';
import { Analytics } from "@vercel/analytics/react"

function App() {

  const [showHowWorks, setShowHowWorks] = useState(false)
  const [showFAQ, setShowFAQ] = useState(false)
  const [showAddCareer, setShowAddCareer] = useState(false)
  const [showAddOpinion, setShowAddOpinion] = useState(false)
  const [showDeleteCareer, setShowDeleteCareer] = useState(false)
  const [showAddTutor, setShowAddTutor] = useState(false)
  const [myTutor, setMyTutor] = useState(null)
  const [career, setCareer] = useState(null)

  const toggleHowWorks = () => {
    setShowHowWorks(!showHowWorks)
  }
  
  const toggleAddCareer = () => {
    setShowAddCareer(!showAddCareer)
  }
  
  const toggleAddOpinion = () => {
    console.log("dsaasddsadas");
    
    setShowAddOpinion(!showAddOpinion)
  }

  const toggleFAQ = () => {
    setShowFAQ(!showFAQ)
  }

  const toggleAddTutor = async () => {
    if (!showAddTutor) {
      const userId = localStorage.getItem('userId')
      if (userId) {
        const resp = await getTutorByUser(userId)
        setMyTutor(resp.tutor || null)
      }
    }
    setShowAddTutor(!showAddTutor)
  }
  
  const toggleDeleteCareer = (car) => {
    if(car){
      setCareer(car)
    }
    setShowDeleteCareer(!showDeleteCareer)
  }

  return (
    <BrowserRouter>
  
      <div className="app">

        {showFAQ && <FAQPage toggleFAQ={toggleFAQ}/>}
        {showAddCareer && <AddCareerContainer toggleAddCareer={toggleAddCareer}/>}
        {showAddOpinion && <AddOpinionContainer toggleAddOpinion={toggleAddOpinion}/>}
        {showAddTutor && <AddTutorContainer toggle={toggleAddTutor} existingTutor={myTutor}/>}

        {showHowWorks && <HowWorksContainer toggleHowWorks={toggleHowWorks}/>}
        {showDeleteCareer && <DeleteCareerContainer career={career} toggleDeleteCareer={toggleDeleteCareer}/>}

        <Routes className="main-view">
            
            <Route exact path="/home" element={<HomeContainer path='/home' toggleDeleteCareer={toggleDeleteCareer} toggleAddCareer={toggleAddCareer} toggleHowWorks={toggleHowWorks}/>}/>
            <Route exact path="/schedule" element={<HomeContainer path='/schedule'/>}/>
            <Route exact path="/opinions" element={<HomeContainer path='/opinions' toggleAddOpinion={toggleAddOpinion}/>}/>
            <Route exact path="/tutors" element={<HomeContainer path='/tutors' toggleAddTutor={toggleAddTutor}/>}/>
            {/* <Route exact path="/home" element={<MyCareersPage toggleDeleteCareer={toggleDeleteCareer} toggleAddCareer={toggleAddCareer} toggleHowWorks={toggleHowWorks}/>}/> */}
            <Route exact path="/" element={<LoginPage toggleFAQ={toggleFAQ} />}/>
            <Route exact path="/register" element={<RegisterPage/>}/>
            <Route exact path="/faq" element={<FAQPage/>}/>
            <Route exact path="/forgot-password" element={<ForgotPasswordPage />}/>
            <Route exact path="*" element={<Navigate to="/"/>}/>
            <Route exact path="/reset-password/:resetToken" element={<ResetPasswordPage />}/>
            <Route exact path="/verification/:userId" element={<VerificacionMailPage />}/>
        </Routes>
      </div>
      <Analytics/>
    </BrowserRouter>
  );
}

export default App;
